import React, { useEffect, useState } from "react";
import PassTemplate from "../Modals/PassTemplate";
import { useTranslation } from "react-i18next";
import Plan from "../Modals/Plan";
import OrganizationAxiosInstance from "../Services/OrganizationAxiosInstance";
import { HiMapPin, HiTrash, HiPlus } from "react-icons/hi2";

interface LocationsFormProps {
  activeTab: string;
  passTemplate: PassTemplate | null;
  setModalHidden: (hidden: boolean) => void;
  removeLocation: (index: number) => void;
  UpdateLocations: () => void;
  onNotificationChange: (index: number, value: string) => void;
}

const LocationsForm: React.FC<LocationsFormProps> = ({
  activeTab, passTemplate, setModalHidden, removeLocation,
  UpdateLocations, onNotificationChange,
}) => {
  const { t } = useTranslation();
  const [organizationPlan, setOrganizationPlan] = useState<Plan>();

  useEffect(() => {
    async function fetchPlans() {
      try {
        const plans: Plan[] = (await OrganizationAxiosInstance.get("/Plans/")).data;
        setOrganizationPlan(plans.find(p => p.id === passTemplate?.organization?.planId));
      } catch {}
    }
    fetchPlans();
  }, []);

  const canAddMore = !organizationPlan?.allowedLocations ||
    !passTemplate?.locations ||
    passTemplate.locations.length < organizationPlan.allowedLocations;

  const inputClass = "w-full px-3 py-2 rounded-xl border border-gray-200 bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-transparent transition";

  return (
    <div className={activeTab === "locations" ? "block space-y-4 pt-4" : "hidden"}>

      {/* Existing locations */}
      {passTemplate?.locations && passTemplate.locations.length > 0 && (
        <div className="bg-gray-50 rounded-2xl border border-gray-200 divide-y divide-gray-200 overflow-hidden">
          {passTemplate.locations.map((location, index) => (
            <div key={location.id || index} className="p-4 space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg bg-brand-50 flex items-center justify-center flex-shrink-0">
                    <HiMapPin className="w-4 h-4 text-brand-500" />
                  </div>
                  <p className="text-sm font-semibold text-gray-800">{location.name}</p>
                </div>
                <button
                  type="button"
                  onClick={() => removeLocation(index)}
                  className="p-1.5 rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-500 transition"
                >
                  <HiTrash className="w-4 h-4" />
                </button>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">{t("Auto Notification")}</label>
                <input
                  type="text"
                  value={location.autoNotification}
                  onChange={e => onNotificationChange(index, e.target.value)}
                  placeholder={t("Auto Notification")}
                  className={inputClass}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {canAddMore && (
        <button
          type="button"
          onClick={() => setModalHidden(false)}
          className="w-full py-2.5 rounded-xl border-2 border-dashed border-brand-300 text-brand-600 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-brand-50 transition"
        >
          <HiPlus className="w-4 h-4" />{t("Add Location")}
        </button>
      )}

      <button
        type="button"
        onClick={UpdateLocations}
        className="w-full py-3 rounded-xl bg-brand-600 text-white text-sm font-bold hover:bg-brand-700 transition active:scale-95"
      >
        {t("Save Changes")}
      </button>
    </div>
  );
};

export default LocationsForm;
